import { render, staticRenderFns } from "./bigData.vue?vue&type=template&id=440bad02&scoped=true"
import script from "./bigData.vue?vue&type=script&lang=js"
export * from "./bigData.vue?vue&type=script&lang=js"
import style0 from "./bigData.vue?vue&type=style&index=0&id=440bad02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440bad02",
  null
  
)

export default component.exports